import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // model
  screenIdMstModel: [],

  //form
  buttonId: null,
  index: 0,

  // 選択されたファイル情報
  value: null,

  // モーダルに重ねて表示する場合true
  overlay: false,
}

const getters = {
	get: state => state,

  // screenIdMstUuidから画面名を取得
  getScreenName: state => screenIdMstUuid => {
    try {
      return state.screenIdMstModel.filter(item => item.screenIdMstUuid === screenIdMstUuid)[0].screenName
    // eslint-disable-next-line
    } catch (e) {
      return ''
    }
  }
}

const actions = {
	show ({commit}, {buttonId, index, overlay}) {
		// cover
		this.dispatch('core/showModalCover')
		
    commit('setButtonId', buttonId)
    if (index !== undefined) {
      commit('setIndex', index)
    }

    if (overlay === undefined) {
      commit('setOverlay', false)
    } else {
      commit('setOverlay', overlay)
    }

		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
    if (state.overlay) return

		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
	},

  /**
   * 初期データを読出し
   */
  loadModel ({commit}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['screenIdMst'],
        ['v1ScreenIdMstListGet'],
        [{}])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setScreenIdMstModel', res[0].data.screenIdMsts)
            console.log('screenIdMstModel', state.screenIdMstModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * 選択されたファイル情報を保持
   */
  setValue ({commit}, data) {
    commit('setValue', data)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // model
  setScreenIdMstModel (state, data) {
    Vue.set(state, 'screenIdMstModel', data)
  },
  
  // form
  setButtonId (state, id) {
    state.buttonId = id
  },
  setIndex (state, index) {
    state.index = index
  },
  setValue (state, data) {
    Vue.set(state, 'value', data)
  },

  // overlay
  setOverlay (state, flag) {
    state.overlay = flag
    console.log('actions', flag)
  },

  // reset
  reset (state) {
    Vue.set(state, 'screenIdMstModel', [])
    Vue.set(state, 'value', null)
    // state.overlay = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
